import { Component, OnInit } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'fc-user-review',
  templateUrl: './user-review.component.html',
  styleUrls: ['./user-review.component.css'],
})
export class UserReviewComponent implements OnInit {
  faSearch = faSearch;
  activeContent: string = 'pending';
  navs: any = [
    {
      name: 'Pending Review',
      link: '/user/review/pending',
    },
    {
      name: 'History',
      link: '/user/review/history',
    },
  ];
  constructor() {}

  ngOnInit(): void {}

  filterReview(event: any) {}
}
